import { FormNodeSubheaderModel } from '../../../../../shared/kiosk';
import { AbstractElementEditor } from './AbstractElementEditor';

export class SubheaderEditor extends AbstractElementEditor<FormNodeSubheaderModel> {
  public getDescription(): string {
    return 'Subheader';
  }

  public getName(): string {
    return 'Subheader';
  }

  public getIcon(): string {
    return 'text_fields';
  }
}
